import React from "react";
import { Controller, Path, useFormContext } from "react-hook-form";

import { InputWithAutocomplete } from "../../../../../HookForm/InputWithAutocomplete";
import { CategoryAutocompleter } from "../CategoryAutocompleter";
import { GbpCategories } from "../types";

interface CategoryAutocompleteInputProps {
  name: Path<GbpCategories>;
}

export const CategoryAutocompleteInput = (
  props: CategoryAutocompleteInputProps
) => {
  const { control } = useFormContext<GbpCategories>();
  return (
    <Controller
      control={control}
      name={props.name}
      rules={{
        deps: "additionalCategories",
      }}
      render={({ field }) => (
        <InputWithAutocomplete
          name={field.name}
          autoCompleteFormula={CategoryAutocompleter.performAutocomplete}
        />
      )}
    />
  );
};
